import type { FC } from "react"

interface BackgroundMediaProps {
  bgSource?: string
  bgColor: string
  showContentMargin?: boolean
  className?: string
  mediaClassName?: string
  overlayClassName?: string
}

const getTransparentColorStop = (color: string) => {
  const trimmedColor = color.trim()
  const hexMatch = trimmedColor.match(/^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6}|[0-9a-fA-F]{8})$/)

  if (!hexMatch) return "transparent"

  const hexValue = hexMatch[1]
  const normalizedHex =
    hexValue.length === 3
      ? hexValue
          .split("")
          .map((char) => `${char}${char}`)
          .join("")
      : hexValue.slice(0, 6)

  return `#${normalizedHex}00`
}

const BackgroundMedia: FC<BackgroundMediaProps> = ({
  bgSource,
  bgColor,
  showContentMargin = false,
  className = "",
  mediaClassName,
  overlayClassName,
}) => {
  if (!bgSource) return null
  const defaultMediaClassName = `object-cover w-[100vw] h-full no-repeat ${
    showContentMargin ? "sm:w-[calc(100vw-200px)] sm:ml-[200px]" : ""
  }`
  const resolvedMediaClassName = mediaClassName ?? defaultMediaClassName
  const resolvedBgColor = bgColor.trim()
  const gradientStartColor = getTransparentColorStop(resolvedBgColor)

  return (
    <div
      className={`fixed top-0 sm:top-0 left-0 sm:h-[900px] h-screen w-screen z-0 pointer-events-none ${className}`}
      style={{ backgroundColor: resolvedBgColor || undefined }}
    >
      {bgSource.includes("video") ? (
        <video
          autoPlay
          className={resolvedMediaClassName}
          controls={false}
          loop
          muted
          playsInline
          preload="metadata"
          src={bgSource}
        />
      ) : (
        <img alt="" className={resolvedMediaClassName} src={bgSource} />
      )}
      {overlayClassName ? <div className={`absolute inset-0 ${overlayClassName}`} /> : null}
      {resolvedBgColor ? (
        <div
          className="absolute bottom-0 h-[256px] w-full"
          style={{
            backgroundImage: `linear-gradient(to bottom, ${gradientStartColor}, ${resolvedBgColor})`,
          }}
        />
      ) : null}
    </div>
  )
}

export default BackgroundMedia
